(function () {
  function init(root) {
    if (!root || root.dataset.homeInitialized === 'true') return;
    root.dataset.homeInitialized = 'true';

    const toggles = Array.from(root.querySelectorAll('[data-symptom-toggle]'));
    const feedback = root.querySelector('[data-symptoms-feedback]');
    const cta = root.querySelector('[data-symptoms-cta]');
    const ctaLink = cta?.querySelector('a');
    const menotest = document.querySelector('[data-home-module="menotest"], .home-menotest-root');
    const target = menotest?.querySelector('[data-symptoms-cta-target], .home-menotest__button--primary')
      || document.querySelector('[data-symptoms-cta-target], .home-menotest__button--primary');
    const boundary = document.querySelector('[data-symptoms-cta-boundary]') || menotest;
    const originalTabIndex = ctaLink?.getAttribute('tabindex');
    const targetTabIndex = target?.getAttribute('tabindex');
    const handoffMedia = window.matchMedia('(max-width: 69.9375rem)');
    const reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
    let hasSelection = false;
    let ctaEligible = false;
    let ctaCanTravel = false;
    let ctaOriginTop = null;
    let ctaOriginHeight = 0;
    let selectionScrollY = 0;
    let travelFrame = 0;
    let travelState = null;

    function syncTargetHandoff(isProxied) {
      if (!target) return;

      if (isProxied) {
        target.setAttribute('data-symptoms-cta-proxied', 'true');
        target.setAttribute('aria-hidden', 'true');
        target.setAttribute('inert', '');
        target.setAttribute('tabindex', '-1');
        return;
      }

      target.removeAttribute('data-symptoms-cta-proxied');
      target.setAttribute('aria-hidden', 'false');
      target.removeAttribute('inert');
      if (targetTabIndex === null) target.removeAttribute('tabindex');
      else target.setAttribute('tabindex', targetTabIndex);
    }

    function getTravelBottomOffset() {
      if (window.innerWidth <= 767) return 12;
      return Math.min(32, Math.max(16, window.innerWidth * 0.025));
    }

    function measureCtaOrigin() {
      if (!cta || cta.hidden) return;
      const rect = cta.getBoundingClientRect();
      ctaOriginTop = rect.top + window.scrollY;
      ctaOriginHeight = rect.height;
    }

    function isTargetVisuallyReady(targetRect) {
      if (!target) return false;
      if (!targetRect || targetRect.width <= 0 || targetRect.height <= 0) return false;
      const revealContainer = target.closest('.home-section-reveal');
      if (!revealContainer) return true;
      const styles = window.getComputedStyle(revealContainer);
      return styles.visibility !== 'hidden' && Number.parseFloat(styles.opacity) > 0;
    }

    function setCtaState(nextState) {
      if (!cta) return;
      const shouldProxyTarget = nextState === 'traveling' && handoffMedia.matches;
      if (travelState === nextState) {
        syncTargetHandoff(shouldProxyTarget);
        return;
      }
      travelState = nextState;

      const isInactive = nextState === 'inactive';
      const isAtTarget = nextState === 'at-target';
      const isAtBoundary = nextState === 'at-boundary';
      const isFixed = nextState === 'traveling';

      cta.hidden = isInactive || isAtTarget || isAtBoundary;
      cta.classList.toggle('home-symptoms__cta--fixed', isFixed);
      cta.classList.toggle('home-symptoms__cta--at-target', isAtTarget);
      cta.dataset.symptomsCtaState = nextState;
      cta.setAttribute('aria-hidden', String(isInactive || isAtTarget || isAtBoundary));

      if (isInactive || isAtTarget || isAtBoundary) {
        cta.setAttribute('inert', '');
        if (ctaLink) ctaLink.setAttribute('tabindex', '-1');
      } else {
        cta.removeAttribute('inert');
        if (ctaLink) {
          if (originalTabIndex === null) ctaLink.removeAttribute('tabindex');
          else ctaLink.setAttribute('tabindex', originalTabIndex);
        }
      }

      syncTargetHandoff(shouldProxyTarget);
    }

    function updateTravelState() {
      travelFrame = 0;
      if (!cta) return;

      if (!ctaEligible) {
        setCtaState('inactive');
        return;
      }

      // Do not let the traveling CTA follow the user above its Symptoms origin.
      if (root.getBoundingClientRect().top > window.innerHeight) {
        setCtaState('local');
        return;
      }

      if (!ctaCanTravel) {
        if (window.scrollY <= selectionScrollY + 2) {
          setCtaState('local');
          return;
        }
        ctaCanTravel = true;
      }

      if (ctaOriginTop === null) measureCtaOrigin();

      if (ctaOriginTop !== null) {
        const activationTop = window.innerHeight - ctaOriginHeight - getTravelBottomOffset();
        const naturalTop = ctaOriginTop - window.scrollY;

        if (travelState !== 'traveling' && naturalTop > activationTop) {
          setCtaState('local');
          return;
        }

        if (travelState === 'traveling' && naturalTop > activationTop + 8) {
          setCtaState('local');
          return;
        }
      }

      if (!target && !boundary) {
        setCtaState('local');
        return;
      }

      setCtaState('traveling');

      if (target) {
        const ctaRect = cta.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();

        // Never let the traveling CTA continue below the Menotest action.
        if (targetRect.bottom < 0) {
          setCtaState(handoffMedia.matches ? 'at-target' : 'at-boundary');
          return;
        }

        // Hand off only after the native Menotest CTA is actually visible.
        if (targetRect.top <= ctaRect.bottom + 24 && targetRect.bottom >= 0 && isTargetVisuallyReady(targetRect)) {
          setCtaState('at-target');
        }
        return;
      }

      const boundaryTop = boundary.getBoundingClientRect().top;
      const hasReachedBoundary = boundaryTop <= cta.getBoundingClientRect().top - 24;
      setCtaState(handoffMedia.matches
        ? (hasReachedBoundary ? 'at-target' : 'traveling')
        : (hasReachedBoundary ? 'at-boundary' : 'traveling'));
    }

    function requestTravelState() {
      if (travelFrame) return;
      travelFrame = window.requestAnimationFrame(updateTravelState);
    }

    function updateSelection() {
      const selectedCount = toggles.filter((toggle) => toggle.getAttribute('aria-pressed') === 'true').length;
      const wasEligible = ctaEligible;
      hasSelection = selectedCount > 0;
      ctaEligible = selectedCount >= 3;

      root.classList.toggle('home-symptoms-root--has-selection', hasSelection);
      if (feedback) feedback.hidden = !hasSelection;

      if (ctaEligible && !wasEligible) {
        ctaCanTravel = false;
        ctaOriginTop = null;
        ctaOriginHeight = 0;
        selectionScrollY = window.scrollY;
        setCtaState('local');
      }

      if (!ctaEligible) {
        ctaCanTravel = false;
        ctaOriginTop = null;
        ctaOriginHeight = 0;
      }

      updateTravelState();
    }

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', function () {
        const isSelected = toggle.getAttribute('aria-pressed') === 'true';
        toggle.setAttribute('aria-pressed', String(!isSelected));
        updateSelection();
      });
    });

    updateSelection();
    window.addEventListener('scroll', requestTravelState, { passive: true });
    window.addEventListener('resize', requestTravelState);
    handoffMedia.addEventListener('change', requestTravelState);
    reducedMotionMedia.addEventListener('change', requestTravelState);

    const sectionRevealItems = Array.from(root.querySelectorAll('.home-section-reveal'));
    if ('IntersectionObserver' in window) {
      const sectionRevealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('home-is-visible');
            sectionRevealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

      root.classList.add('home-reveal-motion-ready');
      window.setTimeout(() => {
        sectionRevealItems.forEach((item) => sectionRevealObserver.observe(item));
      }, 120);
    } else {
      sectionRevealItems.forEach((item) => item.classList.add('home-is-visible'));
    }
  }

  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-authoritative]'));
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target?.querySelector?.('[data-home-authoritative]'));
  });
}());
